<div class="filtercontainer row">
    <div class="btn btn-small"></div>
    <button
              mat-stroked-button
              class="btn btn-small"
              title="refresh"
              (click)="refresh()"
              style="vertical-align: middle;"
            >
        <mat-icon title="refresh">refresh</mat-icon>
    </button>
    <div class="input-group-sm mt-1 input-group col-6" style="vertical-align: middle;">
        <input class="form-control" type="search" [(ngModel)]="filterInput"
            (keyup)="applyFilter()" (search)="applyFilter()" placeholder="Filter files">
    </div>
    <!-- <mat-icon style="vertical-align: middle;" (click)="clearFilter()">close</mat-icon> -->    
    <button style="vertical-align: middle;" class="menuButton col-1" *ngIf="selection.selected.length>0" mat-raised-button #authMenu
        [matMenuTriggerFor]="menu">Actions
        <mat-icon>arrow_drop_down</mat-icon>
    </button>            
    <mat-menu class="my-menu" #menu="matMenu">
        <button mat-menu-item (click)="acceptDuplicates()">Accept Duplicates</button>
        <button mat-menu-item (click)="ignoreDuplicates()">Ignore Duplicates</button>
    </mat-menu>    
</div>
<div class="container-fluid">
    <button (click)="onFolderSelect()" class="accordion">My Files ({{myFilesCount}})</button>
    <div class="panel" [ngStyle]="{ display: setFolderActive ? 'block': 'none' } ">
        <div class="content">
            <table mat-table [dataSource]="virtualFolders" aria-describedby="capture-table">
                <ng-container matColumnDef="Folders">
                    <th mat-header-cell *matHeaderCellDef> 
                        <span [style.paddingLeft.px]="40"> Folders </span>
                    </th>
                    <td mat-cell *matCellDef="let node"> 
                        <button id="toggleButton" mat-icon-button 
                                [style.visibility]="!node.expandable ? 'hidden' : ''"
                                [style.marginLeft.px]="node.level * 32"
                                (click)="treeControl.toggle(node)">
                        <mat-icon class="mat-icon-rtl-mirror">
                            {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                        </mat-icon>
                        
                        </button>          
                        <label for="toggleButton" [ngClass]="node.id === selectedFolderId ? 'bold-text' : 'normal-text'" (click)="selectFolder(node.folder_name, node.id)">
                            {{node.folder_name}}
                        </label>                            
                    </td>
                </ng-container>
                <ng-container matColumnDef="Documents">
                    <th mat-header-cell *matHeaderCellDef> Documents </th>
                    <td mat-cell *matCellDef ="let node">
                        <div *ngIf="node.id === selectedFolderId && dupDocList && folderSelected && !noDocuments">
                            <mat-paginator #myPaginator [pageSizeOptions]="[50, 100]" [pageSize]="50" (page)="selectPage($event)" class="custom-paginator" showFirstLastButtons>
                            </mat-paginator>
                        </div>
                        <div *ngIf="node.id === selectedFolderId" class="m-2">
                            <div *ngIf="folderSelected">
                                <div class="Tabletitle">Document List for Folder - {{node.folder_name}}  ({{totalDocumentCount}})                          
            
                                </div>
                                <div *ngIf="noDocuments" class="text-center mt-2">
                                    There are no duplicates files
                                </div>
                            </div>
                        </div>
                        <div *ngIf="dupDocList && node.id === selectedFolderId && folderSelected && !noDocuments">
                            <table mat-table [dataSource]="dupDocList" aria-describedby="capture-table" matSort>                        
                                <ng-container matColumnDef="select">
                                    <th id="select" mat-header-cell *matHeaderCellDef>
                                        Select
                                    </th>
                                    <td mat-cell *matCellDef="let element">
                                        <mat-checkbox (click)="$event.stopPropagation()"
                                            (change)="$event ? selection.toggle(element) : null"
                                            [checked]="selection.isSelected(element)" [aria-label]="checkboxLabel(element)">
                                        </mat-checkbox>
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="documentName">
                                    <th id="documentName" mat-header-cell *matHeaderCellDef mat-sort-header> File Name </th>
                                    <td mat-cell *matCellDef="let element">
                                        <a href="javascript:void(0)" (click)="viewDocument(element)">{{element.documentName}}</a>
                                    </td>
                                </ng-container>
                        
                                <!-- <ng-container matColumnDef="createDate">
                                    <th id="createDate" mat-header-cell *matHeaderCellDef mat-sort-header> Uploaded date </th>
                                    <td mat-cell *matCellDef="let element"> {{element.createDate | date }} </td>
                                </ng-container>
                                <ng-container matColumnDef="createdBy">
                                    <th id="createdBy" mat-header-cell *matHeaderCellDef mat-sort-header> Uploaded By </th>
                                    <td mat-cell *matCellDef="let element"> {{element.createdBy }} </td>
                                </ng-container> -->
                                <ng-container matColumnDef="filesize">
                                    <th id="filesize" mat-header-cell *matHeaderCellDef mat-sort-header> File Size </th>
                                    <td mat-cell *matCellDef="let element"> {{element.filesize}} </td>
                                </ng-container>
                                <ng-container matColumnDef="duplicates">
                                    <th id="duplicates" mat-header-cell *matHeaderCellDef mat-sort-header>Duplicates </th>
                                    <td mat-cell *matCellDef="let element">
                                        <a href="javascript:void(0)" (click)="clickDuplicate(element)">Show/Hide</a>
                                        <div *ngIf="duplicateSubList && showDuplicateLink && element.documentId == selectedDoc">
                                            <table mat-table [dataSource]="duplicateSubList" aria-describedby="capture-table" matSort>                                   
                                                <ng-container matColumnDef="documentName">
                                                    <th id="documentName" mat-header-cell *matHeaderCellDef mat-sort-header> File Name </th>
                                                    <td mat-cell *matCellDef="let element">
                                                        <a href="javascript:void(0)" (click)="viewDocument(element)">{{element.documentName}}</a>
                                                    </td>
                                                </ng-container>
                                        
                                                <ng-container matColumnDef="createDate">
                                                    <th id="createDate" mat-header-cell *matHeaderCellDef mat-sort-header> Uploaded date </th>
                                                    <td mat-cell *matCellDef="let element"> {{element.createDate | date }} </td>
                                                </ng-container>
                                                <ng-container matColumnDef="createdBy">
                                                    <th id="createdBy" mat-header-cell *matHeaderCellDef mat-sort-header> Uploaded By </th>
                                                    <td mat-cell *matCellDef="let element"> {{element.createdBy }} </td>
                                                </ng-container>
                                                <ng-container matColumnDef="filesize">
                                                    <th id="filesize" mat-header-cell *matHeaderCellDef mat-sort-header> File Size </th>
                                                    <td mat-cell *matCellDef="let element"> {{element.filesize}} </td>
                                                </ng-container>
                                                <ng-container matColumnDef="isMigrateToECM">
                                                    <th id="isMigrateToECM" mat-header-cell *matHeaderCellDef mat-sort-header> Exported to ECM </th>
                                                    <td mat-cell *matCellDef="let element"> {{element.isMigrateToECM}} </td>
                                                </ng-container>
                                                <tr mat-header-row *matHeaderRowDef="duplicatedColumns"></tr>
                                                <tr mat-row *matRowDef="let row; columns: duplicatedColumns;"
                                                    class="element-row" [class.selected-row]="selectedRow === row"
                                                    (click)="selectedRow = selectedRow === row ? null : row"
                                                    title="Select Document">
                                                </tr>
                                            </table>
                                        </div>
                                        
                                    </td>
                                </ng-container>
                                <!-- dynamic columns -->
                                <ng-container *ngFor="let column of documentCols">
                                    <ng-container *ngIf="column.indexOf('display_') === 0" matColumnDef="{{column}}">
                                        <th id="{{column | stripDisplay}}" mat-header-cell *matHeaderCellDef mat-sort-header>
                                            {{column | stripDisplay}} </th>
                                        <td mat-cell *matCellDef="let element"> {{ element[column] }} </td>
                                    </ng-container>
                                </ng-container>
                                
                                <!-- end dynamic columns-->
                        
                                <tr mat-header-row *matHeaderRowDef="documentCols"></tr>
                                <!-- <tr mat-row *matRowDef="let row; columns: documentCols;" class="element-row">
                                </tr> -->
                                <tr mat-row *matRowDef="let row; columns: documentCols;"
                                    class="element-row" [class.selected-row]="selectedRow === row"
                                    (click)="selectedRow = selectedRow === row ? null : row"
                                    title="Select Document">
                                </tr>
                        
                                <!-- <tr mat-header-row *matHeaderRowDef="dupDocCols"></tr>
                                <tr mat-row *matRowDef="let row; columns: dupDocCols;" class="element-row">
                                </tr> -->
                                <!-- <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr> -->
                        
                            </table>
                        </div>
                        
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>
    </div>
    <div *ngFor="let team of teams" >
        <button (click)="onTeamSelect(team)" class="accordion">{{team.team_name}} ({{team.count}})</button>
        <div class="panel" [ngStyle]="{ display: team.active ? 'block': 'none' } ">
            <div class="content">
                <table mat-table [dataSource]="virtualFolders" aria-describedby="capture-table">
                    <ng-container matColumnDef="Folders">
                        <th mat-header-cell *matHeaderCellDef> 
                            <span [style.paddingLeft.px]="40"> Folders </span>
                        </th>
                        <td mat-cell *matCellDef="let node"> 
                            <button id="toggleButton" mat-icon-button 
                                    [style.visibility]="!node.expandable ? 'hidden' : ''"
                                    [style.marginLeft.px]="node.level * 32"
                                    (click)="treeControl.toggle(node)">
                            <mat-icon class="mat-icon-rtl-mirror">
                                {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                            </mat-icon>
                            
                            </button>          
                            <label for="toggleButton" [ngClass]="node.id === selectedFolderId ? 'bold-text' : 'normal-text'" (click)="selectTeam(node.folder_name, node.id)">
                                {{node.folder_name}}
                            </label>                            
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="Documents">
                        <th mat-header-cell *matHeaderCellDef> Documents </th>
                        <td mat-cell *matCellDef ="let node">
                            <div *ngIf="node.id === selectedFolderId && dupDocList && folderSelected && !noDocuments">
                                <mat-paginator #myPaginator [pageSizeOptions]="[50, 100]" [pageSize]="50" (page)="selectPage($event)" class="custom-paginator" showFirstLastButtons>
                                </mat-paginator>
                            </div>
                            <div *ngIf="node.id === selectedFolderId" class="m-2">
                                <div *ngIf="folderSelected">
                                    <div class="Tabletitle">Document List for Folder - {{node.folder_name}}  ({{totalDocumentCount}})                          
                
                                    </div>
                                    <div *ngIf="noDocuments" class="text-center mt-2">
                                        There are no duplicates files
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="dupDocList && node.id === selectedFolderId && folderSelected && !noDocuments">
                                <table mat-table [dataSource]="dupDocList" aria-describedby="capture-table" matSort>                        
                                    <ng-container matColumnDef="select">
                                        <th id="select" mat-header-cell *matHeaderCellDef>
                                            Select
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            <mat-checkbox (click)="$event.stopPropagation()"
                                                (change)="$event ? selection.toggle(element) : null"
                                                [checked]="selection.isSelected(element)" [aria-label]="checkboxLabel(element)">
                                            </mat-checkbox>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="documentName">
                                        <th id="documentName" mat-header-cell *matHeaderCellDef mat-sort-header> File Name </th>
                                        <td mat-cell *matCellDef="let element">
                                            <a href="javascript:void(0)" (click)="viewDocument(element)">{{element.documentName}}</a>
                                        </td>
                                    </ng-container>
                            
                                    <ng-container matColumnDef="createDate">
                                        <th id="createDate" mat-header-cell *matHeaderCellDef mat-sort-header> Uploaded date </th>
                                        <td mat-cell *matCellDef="let element"> {{element.createDate | date }} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="createdBy">
                                        <th id="createdBy" mat-header-cell *matHeaderCellDef mat-sort-header> Uploaded By </th>
                                        <td mat-cell *matCellDef="let element"> {{element.createdBy }} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="filesize">
                                        <th id="filesize" mat-header-cell *matHeaderCellDef mat-sort-header> File Size </th>
                                        <td mat-cell *matCellDef="let element"> {{element.filesize}} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="duplicates">
                                        <th id="duplicates" mat-header-cell *matHeaderCellDef mat-sort-header>Duplicates </th>
                                        <td mat-cell *matCellDef="let element">
                                            <a href="javascript:void(0)" (click)="clickDuplicate(element)">Show/Hide</a>
                                            <div *ngIf="duplicateSubList && showDuplicateLink && element.documentId == selectedDoc">
                                                <table mat-table [dataSource]="duplicateSubList" aria-describedby="capture-table" matSort>                                   
                                                    <ng-container matColumnDef="documentName">
                                                        <th id="documentName" mat-header-cell *matHeaderCellDef mat-sort-header> File Name </th>
                                                        <td mat-cell *matCellDef="let element">
                                                            <a href="javascript:void(0)" (click)="viewDocument(element)">{{element.documentName}}</a>
                                                        </td>
                                                    </ng-container>
                                            
                                                    <ng-container matColumnDef="createDate">
                                                        <th id="createDate" mat-header-cell *matHeaderCellDef mat-sort-header> Uploaded date </th>
                                                        <td mat-cell *matCellDef="let element"> {{element.createDate | date }} </td>
                                                    </ng-container>
                                                    <ng-container matColumnDef="createdBy">
                                                        <th id="createdBy" mat-header-cell *matHeaderCellDef mat-sort-header> Uploaded By </th>
                                                        <td mat-cell *matCellDef="let element"> {{element.createdBy }} </td>
                                                    </ng-container>
                                                    <ng-container matColumnDef="filesize">
                                                        <th id="filesize" mat-header-cell *matHeaderCellDef mat-sort-header> File Size </th>
                                                        <td mat-cell *matCellDef="let element"> {{element.filesize}} </td>
                                                    </ng-container>
                                                    <ng-container matColumnDef="isMigrateToECM">
                                                        <th id="isMigrateToECM" mat-header-cell *matHeaderCellDef mat-sort-header> Exported to ECM </th>
                                                        <td mat-cell *matCellDef="let element"> {{element.isMigrateToECM}} </td>
                                                    </ng-container>
                                                    <tr mat-header-row *matHeaderRowDef="duplicatedColumns"></tr>
                                                    <tr mat-row *matRowDef="let row; columns: duplicatedColumns;"
                                                        class="element-row" [class.selected-row]="selectedRow === row"
                                                        (click)="selectedRow = selectedRow === row ? null : row"
                                                        title="Select Document">
                                                    </tr>
                                                </table>
                                            </div>
                                            
                                        </td>
                                    </ng-container>
                                    <!-- dynamic columns -->
                                    <ng-container *ngFor="let column of documentCols">
                                        <ng-container *ngIf="column.indexOf('display_') === 0" matColumnDef="{{column}}">
                                            <th id="{{column | stripDisplay}}" mat-header-cell *matHeaderCellDef mat-sort-header>
                                                {{column | stripDisplay}} </th>
                                            <td mat-cell *matCellDef="let element"> {{ element[column] }} </td>
                                        </ng-container>
                                    </ng-container>
                                    
                                    <!-- end dynamic columns-->
                            
                                    <tr mat-header-row *matHeaderRowDef="documentCols"></tr>
                                    <!-- <tr mat-row *matRowDef="let row; columns: documentCols;" class="element-row">
                                    </tr> -->
                                    <tr mat-row *matRowDef="let row; columns: documentCols;"
                                        class="element-row" [class.selected-row]="selectedRow === row"
                                        (click)="selectedRow = selectedRow === row ? null : row"
                                        title="Select Document">
                                    </tr>
                            
                                    <!-- <tr mat-header-row *matHeaderRowDef="dupDocCols"></tr>
                                    <tr mat-row *matRowDef="let row; columns: dupDocCols;" class="element-row">
                                    </tr> -->
                                    <!-- <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr> -->
                            
                                </table>
                            </div>
                            
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
            </div>
        </div>
    </div>
</div>